import styled from 'styled-components';

const StatusIcon = styled.div.attrs((props) => ({
  className: props.className,
}))`
  .tooltip {
    cursor: pointer;
  }
  .tooltip .tooltipcontent {
    visibility: hidden;
    position: absolute;
    z-index: ${(props): number => props.theme.zIndexFloor.roof};
    background: ${(props): string => props.theme.colors.offWhite};
    height: 3.6rem;
    padding: 0.8rem 1.2rem;
    box-shadow: 0px 1px 5px ${(props): string => props.theme.colors.marinoBlue};
    border-radius: ${(props): string => props.theme.borderRadius.normal};
  }
  .tooltip:hover .tooltipcontent {
    visibility: visible;
    position: absolute;
  }
`;

export { StatusIcon };
